import PropTypes from 'prop-types';
import { memo, useEffect, useRef, useState } from "react";
import { Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { FaEdit } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import CustomModal from "../../../../app/common-components/CustomModal.jsx";
import CustomSelectDropDown from "../../../../app/common-components/CustomSelectDropDown.jsx";
import Spinners from "../../../../app/common-components/Spinner.jsx";
import TypeaheadInput from "../../../../app/common-components/TypeaheadInput.jsx";
import { effciencyApi } from "../../../../app/services/efficiencyApi.js";
import { useCommonAlert } from "../../../../app/utilities/helpers.js";
import AssetConfiguration from "../AssetConfiguration/AssetConfiguration.js";
import BudgetCostConfig from "../BudgetDetails/BudgetTable.js";
import { reviewConfiguration, reviewersList, saveReviewerConfiguration, setCmdbId, userSearchList } from "../cmdb-overview/CMDBSlice.js";
import GoLiveAlertConfigutation from "../GoLiveConfig/GoLiveConfig.js";
import { OWNER_ROLE_MAP } from "../cmdb-overview/Constants.js";
import "../styles.scss";


const CmdbApplicationConfiguration = () => {
    const { state: Id } = useLocation();
    const { callCommonAlert, hideCommonAlert } = useCommonAlert();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const rowId = Id?.id;
    dispatch(setCmdbId(rowId));
    const [getReviewAccess] = effciencyApi.useGetReviewAccessMutation();
    const [getUserAppcode] = effciencyApi.useGetUserAppcodeMutation();
    const [getUserDueDate] = effciencyApi.useGetUserDueDateMutation();
    const [getUserAccessDueDate] = effciencyApi.useGetUserAccessDueDateMutation();
    const [getUserListReview] = effciencyApi.useGetUserListReviewMutation();
    const [getUserDetailsAppConfig] = effciencyApi.useGetUserDetailsAppConfigMutation();
    const [getDeleteUserReviewer] = effciencyApi.useGetDeleteUserReviewerMutation();
    const [getUserAccessReviewAlert] = effciencyApi.useGetUserAccessReviewAlertMutation();
    const { userName } = useSelector((state) => state.common.loggedUser);
    const [reviewAccessData, setReviewAccessData] = useState([]);
    const [userAppCodeData, setUserAppCodeData] = useState([]);
    const [userDueData, setUserDueData] = useState([]);
    const [search, setSearch] = useState([]);
    const [selectedReviewer, setSelectedReviewer] = useState([]);
    const [reviewFrequencyDays, setreviewFrequencyDays] = useState([]);
    const [reviewAlertMail, setreviewAlertMail] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const datePickerRef = useRef(null);
    const [payloadDeleteState, setPayloadDeleteState] = useState(null);
    const [itemsToDelete, setItemsToDelete] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingGet, setIsLoadingGet] = useState(false);
    const [isLoadingSave, setIsLoadingSave] = useState(false);

    const {
        userSearchListData, reviewersListData, reviewConfigurationLoading, saveReviewerConfigurationLoading, reviewConfigurationData, reviewersListLoading
    } = useSelector((state) => state.cmdbId);
    const [selectedDays, setSelectedDays] = useState(reviewConfigurationData?.reviewCycle);
    useEffect(() => {
        fetchDataSearchList();
        fetchData();
    }, []);
    useEffect(() => {
        setReviewAccessData(reviewersListData);
    }, [reviewersListData]);

    const fetchDataSearchList = () => {
        dispatch(reviewersList(rowId))
            .then((response) => {
                const reviewersListsData = response.payload;

                const combinedReviewers = [
                    { fullName: reviewersListsData.managerInfo?.primaryManager, type: OWNER_ROLE_MAP.Primary.displayName },
                    { fullName: reviewersListsData.managerInfo?.secondaryManager, type: OWNER_ROLE_MAP.Secondary.displayName },
                    ...reviewersListsData.reviewers?.map(reviewer => ({ fullName: reviewer.fullName, type: 'manual' }))
                ];

                setReviewAccessData(combinedReviewers);
            })
            .catch((error) => {
                console.error("Error fetching reviewers list:", error);
            });
        dispatch(reviewConfiguration(rowId));
    };

    useEffect(() => {
        if (reviewConfigurationData && reviewConfigurationData.reviewCycle) {
            setSelectedDays(
                ReviewDays.find((option) => option.label === reviewConfigurationData.reviewCycle)
            );
        }
    }, [reviewConfigurationData]);

    const [state, setState] = useState({
        modalOpen: false,
        selectedReviewers: [],
        userDetails: [],
        userAdd: [],
        revieweruser: [],
        reviewerUsersId: [],
    });


    const ReviewDays = [
        {
            label: "Monthly",
            value: "Monthly"
        },
        {
            label: "Quarterly",
            value: "Quarterly"
        },
        {
            label: "Half-Yearly",
            value: "Half-Yearly"
        },
        {
            label: "Yearly",
            value: "Yearly"
        }
    ];
    const AlertDays = [
        {
            label: "Day",
            value: "day"
        }
    ];

    useEffect(() => {
        if (userName !== "") {
            dispatch(userSearchList({ cmdbId: rowId }))
                .unwrap()
                .then((data) => {
                    const allReviewerIds = [
                        ...state.revieweruser.map(user => user.id),
                        ...state.selectedReviewers.map(user => user.id),
                    ];

                    const filteredUsers = data.filter(
                        user => !allReviewerIds.includes(user.id)
                    );

                    setState((state) => ({
                        ...state,
                        userDetails: filteredUsers.map((user) => ({
                            label: user.fullName,
                            value: user.fullName,
                            displayName: user.fullName,
                            mail: user.email,
                            id: user.id
                        })),
                    }));
                });
        }
    }, [rowId, userName, state.revieweruser, state.selectedReviewers]);


    const getRowId = rowId;

    const fetchData = async () => {
        setIsLoadingGet(true);
        try {
            if (getRowId) {
                const userAppCodeResponse = await getUserAppcode(getRowId);
                const userDueDateResponse = await getUserDueDate(getRowId);
                setUserAppCodeData(userAppCodeResponse?.data ?? userAppCodeResponse ?? []);
                setUserDueData(userDueDateResponse?.data ?? userDueDateResponse ?? []);
            }
            const getReviewersList = reviewersListData?.reviewers;
            const { primaryManager, secondaryManager, secondaryManagerId, primaryManagerId, } = reviewersListData?.managerInfo;
            setState((state) => ({
                ...state,
                revieweruser: [
                    { fullName: primaryManager, id: primaryManagerId, type: 'P' },
                    { fullName: secondaryManager, id: secondaryManagerId, type: 'S' },
                    ...getReviewersList.map(item => ({ fullName: item.fullName, id: item.id, type: "manual" }))
                ],
                reviewerUsersId: [
                    getReviewersList.map((item) => item.id)
                ]
            }));

            setSelectedDays(
                ReviewDays.find((option) => option.label === reviewConfigurationData?.reviewCycle)
            );

        } catch (error) {
            console.error("Error fetching data:", error);
        }
        setIsLoadingGet(false);
    };

    const handleAddReviewer = () => {
        if (selectedReviewer.length === 0) { return; }

        const newReviewer = selectedReviewer[0];
        const newReviewerLabel = newReviewer.label;

        // Check if already in revieweruser (P/S/manual)
        const isAlreadyInReviewerUser = state.revieweruser.some(
            (user) => user.fullName === newReviewerLabel
        );

        // Check if already in selectedReviewers
        const isAlreadyInSelected = state.selectedReviewers.some(
            (user) => user.label === newReviewerLabel
        );

        if (isAlreadyInReviewerUser || isAlreadyInSelected) {
            callCommonAlert("warning", "Selected reviewer already exist.");
            hideCommonAlert();
            return;
        }

        // Get ID of new reviewer from userSearchListData
        const matchedUser = userSearchListData.find(
            (item) => item.fullName === newReviewerLabel
        );

        setState((prevState) => ({
            ...prevState,
            selectedReviewers: [...prevState.selectedReviewers, newReviewer],
            reviewerUsersId: [...prevState.reviewerUsersId, matchedUser.id],
        }));

        setSelectedReviewer([]);
        setInputValue('');
    };

    const handleRemoveUsers = async (itemToRemoveId) => {
        // Only remove from revieweruser if type is "manual" and ID matches
        setState((prevState) => {
            const updatedReviewerUsers = prevState.revieweruser.filter(
                (user) => !(user.id === itemToRemoveId && user.type === "manual")
            );

            const updatedReviewerUsersId = updatedReviewerUsers
                .filter((u) => u.type === "manual")
                .map((u) => u.id);

            const updatedItemsToDelete = [...itemsToDelete, itemToRemoveId];

            const payloadDelete = {
                cmdbId: rowId,
                usernames: updatedItemsToDelete,
            };

            setItemsToDelete(updatedItemsToDelete);
            setPayloadDeleteState(payloadDelete);

            return {
                ...prevState,
                revieweruser: updatedReviewerUsers,
                reviewerUsersId: [updatedReviewerUsersId],
            };
        });
    };


    const handleRemoveReviewer = (reviewerToRemove) => {
        setState((prevState) => ({
            ...prevState,
            selectedReviewers: prevState.selectedReviewers.filter(
                (r) =>
                    !(
                        r.label === reviewerToRemove.label &&
                        r.value === reviewerToRemove.value &&
                        r.type === reviewerToRemove.type // 👈🏽 This ensures only the exact match gets removed
                    )
            ),
            reviewerUsersId: prevState.reviewerUsersId.filter(
                (id, idx) =>
                    !(
                        id === reviewerToRemove.value &&
                        prevState.selectedReviewers[idx]?.type === reviewerToRemove.type // match index+type
                    )
            )
        }));
    };



    const userhandleSearch = (searchString, IterationList) => {
        const matchedUsers = IterationList.filter((item) =>
            item.label.toLowerCase().includes(searchString.toLowerCase())
        );
        setSearch(matchedUsers);
    };

    const handleSelectedDays = (selectDays) => {
        setSelectedDays(selectDays);
        setreviewAlertMail(1);

    };
    const handleAlertDays = (alertDays) => {
        const selectedDaysValue = selectedDays.value;
        let convertedFrequencyDays = reviewFrequencyDays;

        if (selectedDaysValue === 'month') {
            convertedFrequencyDays *= 30;
        }
        else if (selectedDaysValue === 'week') {
            convertedFrequencyDays *= 7;
        }
        else if (selectedDaysValue === 'year') {
            convertedFrequencyDays *= 365;
        }

        if (alertDays > convertedFrequencyDays) {
            callCommonAlert("warning", `Alert days should not exceed ${selectedDaysValue}`);
            hideCommonAlert();
        } else {
            hideCommonAlert();
            setreviewAlertMail(alertDays);
        }
    };

    const handleSaveReview = async () => {
        if ((!selectedDays || !selectedDays.value)) {
            callCommonAlert("warning", "Please check all the fields are filled");
            hideCommonAlert();
        } else {

            let mergedArray = state.revieweruser.concat(state.selectedReviewers.map(item => item.value));

            const payload = {
                cmdbId: rowId,
                usernames: mergedArray,
            };
            setState(State => ({
                ...State,
                selectedReviewers: [],
            }));
            const payloadDays = {
                noOfDays: reviewFrequencyDays,
                value: 1,
                type: selectedDays?.value,
                alertDays: reviewAlertMail,
                id: rowId,
            };
            const payloadAlert = {
                alertDays: parseInt(reviewAlertMail),
                value: 1,
                id: rowId,
            };
            const manualReviewersIds = state.revieweruser.filter(item => item.type === "manual").map(item => item.id);
            const selectedReviewersIds = state.selectedReviewers.map(item => item.id);
            const finalUserIds = [...manualReviewersIds, ...selectedReviewersIds];

            const savePayLoad = {
                "cmdbId": rowId,
                "userIds": finalUserIds,
                "reviewCycle": selectedDays?.value
            };
            const payLoad = savePayLoad;
            setIsLoadingSave(true);
            setIsLoading(true);
            dispatch(saveReviewerConfiguration({ payLoad })).then((response) => {
                if (response.payload.statusCodeValue === 200) {
                    callCommonAlert("success", response.payload.body);
                    fetchDataSearchList();
                }
                else if (response.payload.statusCodeValue === 400) {
                    callCommonAlert("error", response.payload.body);
                }
                hideCommonAlert();
            });
            handleClose();
            setIsLoading(false);
        }
    };

    const handleShow = () => {
        dispatch(reviewConfiguration(rowId));
        setSelectedDays(reviewConfigurationData?.reviewCycle);
        setState({
            ...state,
            modalOpen: true,
            selectedReviewers: []
        });
        setSelectedReviewer([]);
        setreviewFrequencyDays(userDueData ? userDueData.inputDays : '');
        setreviewAlertMail(userDueData ? userDueData.alertDaysForMail : '');
        fetchData();
        fetchDataSearchList();
        setInputValue("");
    };

    const handleInputChange = (value) => {
        setInputValue(value.length == 0 ? '' : value);
    };

    const isButtonDisabled = inputValue === '';
    const modalBody = () => (
        <>

            <h3 className="editUserAcessReviewer">Update User Access Review</h3>
            {saveReviewerConfigurationLoading || reviewersListLoading || reviewConfigurationLoading ? (
                <Spinners />
            ) : (
                <>
                    <Row className="m-0">
                        <Col xxl={12} xl={12} lg={12} md={12} className="p-0">
                            <div>
                                <label>Reviewers</label>
                                <div className="displayReviewers ">
                                    <span className={`input-group`} >
                                        {state.revieweruser.map((item, index) => (
                                            <span key={item} className="mx-1 mt-3">
                                                <span
                                                    className={`cmdbUserList ${index === 0 ? 'first-user' : index === 1 ? 'second-user' : ''}`}
                                                >
                                                    {item.fullName}
                                                </span>
                                                {index === 0 || index === 1 ? (
                                                    <span className="cmdbUserListPrimary">{index === 0 ? 'P' : 'S'}</span>
                                                ) : (
                                                    <span className="cmdbUserListButton" onClick={() => handleRemoveUsers(item.id)}>
                                                        X
                                                    </span>
                                                )}
                                            </span>
                                        ))}

                                        {state.selectedReviewers.map((user, index) => (
                                            <span className="mx-1 mt-3" key={index}>
                                                <span className="cmdbUserList">{user.label}</span>
                                                <span className="cmdbUserListButton" onClick={() => handleRemoveReviewer(user)}>
                                                    X
                                                </span>
                                            </span>
                                        ))}

                                    </span>

                                </div>
                            </div>
                            <div className="row m-0">
                                <div className="mt-3 border-0 reviewerClass col-6 p-0">
                                    <TypeaheadInput
                                        options={search}
                                        placeholder="Enter Reviewer"
                                        containerClassName={"frmgroup validate default-input col-10 p-0"}
                                        customClassName="reviewerSelect border rounded"
                                        onSearch={(searchString) =>
                                            userhandleSearch(searchString, state.userDetails)
                                        }
                                        selected={selectedReviewer}
                                        onChange={(selected) => {
                                            setSelectedReviewer(selected);
                                            handleInputChange(selected);
                                        }}
                                        error={state.error}
                                        errorMessage={state.errorMessage}
                                    />
                                    {isButtonDisabled ? (
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={<Tooltip> Please Select Any User </Tooltip>}
                                        >
                                            <div className="customPosition">
                                                <button className='btn btn-md btn-primary' disabled

                                                >Add</button>
                                            </div>
                                        </OverlayTrigger>
                                    ) : (
                                        <button className='btn btn-md btn-primary customPosition' onClick={handleAddReviewer}

                                        >Add</button>
                                    )}

                                </div>
                                <Row className="customUserInput col-6 p-0">
                                    <Col className="col-5 customUserInput_head"><span>Review Cycle : </span></Col>
                                    {/* <Col className="col-md-3 p-0"><input
                                type="number"
                                className="form-control h-100 userAccessInput"
                                id="numberInput"
                                onFocus={(e) => e.target.addEventListener('wheel', (evt) => { evt.preventDefault(); })}
                                ref={datePickerRef}
                                value={reviewFrequencyDays}
                                onChange={e => {
                                    if(e.target.value == "") {
                                        e.target.value = 0;
                                    }
                                    handleAlertDays(0);
                                    const freq = Number(e.target.value);
                                    setreviewFrequencyDays(freq)
                                }}
                                onInput={(e) => {
                                    e.target.value = Math.max(1, parseInt(e.target.value)).toString().slice(0, 3);
                                }}
                            />
                            </Col> */}
                                    <Col className="col-md-5">
                                        <CustomSelectDropDown
                                            containerClassName={"p-0 validate default-input sizeValue h-25"}
                                            isSearchable={false}
                                            options={ReviewDays}
                                            noOptionSorting={true}
                                            isMulti={false}
                                            hideSelectedOptions={false}
                                            closeMenuOnSelect={true}
                                            value={selectedDays}
                                            onChange={(selectDays) =>
                                                handleSelectedDays(selectDays)}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                    <div
                        className="server-btn"
                        style={{ display: "block", justifyContent: "end" }}
                    >
                        <button className="cancelBtnStyle btn btn-primary"
                            data-testid="cancelBtn"
                            onClick={() => handleClose()}>Cancel</button>
                        <button className="btnStyle btn btn-primary"
                            data-testid="saveBtn"
                            onClick={() => {
                                handleSaveReview();
                            }}>Save</button>
                    </div>
                </>
            )}
        </>
    );

    const handleClose = () => {
        setState({
            ...state,
            modalOpen: false,
        });
    };
    return (
        <>
            <div className="config_cover">

                <table>
                    <tr>
                        <td>Application Name</td>
                        <td>:</td>
                        <td>{userAppCodeData?.appName ? userAppCodeData?.appName : "-"}</td>
                    </tr>
                    <tr>
                        <td>Criticality</td>
                        <td>:</td>
                        <td>{userAppCodeData?.criticality ? userAppCodeData?.criticality : "-"}</td>
                    </tr>
                    <tr>
                        <td>Department Head</td>
                        <td>:</td>
                        <td>{userAppCodeData?.departmentHead ? userAppCodeData?.departmentHead : "-"}</td>
                    </tr>
                    <tr>
                        <td>Business Department</td>
                        <td>:</td>
                        <td>{userAppCodeData?.businessDepartment ? userAppCodeData?.businessDepartment : "-"}</td>
                    </tr>
                </table >

                {isLoading ? (
                    <div>
                        <Spinners
                            className="dashcol bg-white mt-3 accessReviewerLoader"
                        />
                    </div>
                ) : (
                    <div className="dashcol bg-white mt-3">
                        <h4>Application User Access Review <button className="solid-btn mx-2 float-right" onClick={() => handleShow()}>Edit<FaEdit className="cmdbImgIcon mx-1" /></button></h4>
                        {reviewersListLoading ? <Spinners /> :
                            <div className="accessReviewRow">
                                <div className="reviewersGroup">
                                    <bold>Reviewers :</bold>
                                    {reviewAccessData.length === 0 ? <span className="fw-normal"> Not Available </span> :
                                        <span className="d-flex flex-wrap gap-2">
                                            {Array.isArray(reviewAccessData) && reviewAccessData.map((item, index) => (
                                                item?.fullName ? (() => {
                                                    const ownerRole = Object.values(OWNER_ROLE_MAP).find(r => r.displayName === item.type);
                                                    return (
                                                        <span key={index} className="mx-1 d-inline-flex align-items-center">
                                                            <span className={`cmdbUserList ${ownerRole ? 'first-user' : ''}`}>
                                                                {item.fullName}
                                                            </span>
                                                            {ownerRole && (
                                                                <span className="cmdbUserListPrimary" title={ownerRole.title}>
                                                                    {item.type}
                                                                </span>
                                                            )}
                                                        </span>
                                                    );
                                                })() : null
                                            ))}
                                        </span>
                                    }
                                </div>
                                <div className="reviewFrequency">
                                    <bold>Review Frequency :&nbsp;</bold>
                                    <span className="text-capitalize fw-normal">
                                        {reviewConfigurationData?.reviewCycle || 'Not Available'}
                                    </span>
                                </div>
                            </div>
                        }
                    </div>
                )}
                <GoLiveAlertConfigutation />
                {/* <CloudBudgetCost /> */}
                <AssetConfiguration />
                <BudgetCostConfig />
                <CustomModal
                    modalOpen={state.modalOpen}
                    modalBody={modalBody}
                    closeBtn={true}
                    closeBtnFuc={handleClose}
                    size={'lg'}
                />
            </div>
        </>
    );
};

export default memo(CmdbApplicationConfiguration);

CmdbApplicationConfiguration.propTypes = {
    getRowId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // used in fetchData
    reviewConfigurationData: PropTypes.shape({
        reviewCycle: PropTypes.string
    }),
    reviewersListData: PropTypes.shape({
        reviewers: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string,
                fullName: PropTypes.string
            })
        ),
        managerInfo: PropTypes.shape({
            primaryManager: PropTypes.string,
            primaryManagerId: PropTypes.string,
            secondaryManager: PropTypes.string,
            secondaryManagerId: PropTypes.string,
        }),
    }),
    saveReviewerConfigurationLoading: PropTypes.bool,
    reviewersListLoading: PropTypes.bool,
    reviewConfigurationLoading: PropTypes.bool,
    handleClose: PropTypes.func,
    handleSaveReview: PropTypes.func,
};
